import "./App.css";
import Footer from "./components/Footer/Footer";
import Header from "./components/Header/Header";
import Main from "./components/Main/Main";
let store = {
  state: {
    repairClutch: [
      {
        id: 1,
        title: "Замена сцепления(комплект)",
        price: "от 6000 ₽",
      },
      {
        id: 2,
        title: "Замена рабочего циллиндра сцепления",
        price: "от 630 ₽",
      },
      {
        id: 3,
        title: "Прокачка контура сцепления",
        price: "от 630 ₽",
      },
      {
        id: 4,
        title: "Замена главного циллиндра сцепления",
        price: "от 1500 ₽",
      },
      {
        id: 5,
        title: "С/у АКПП(МКПП)легкового моноприводного а/м",
        price: "от 6000 ₽",
      },
      {
        id: 6,
        title: "Сборка/разборка АКПП (МКПП) легкового моноприводного а/м",
        price: "от 7000 ₽",
      },
      {
        id: 7,
        title: "С/у АКПП (МКПП) полноприводного а/м",
        price: "от 8000 ₽",
      },
      {
        id: 8,
        title: "Сборка/разборка АКПП (МКПП) полноприводного а/м",
        price: "от 9000 ₽",
      },
      {
        id: 9,
        title: "Сборка/разборка АКПП (МКПП) тяжелого внедорожного а/м",
        price: "от 12000 ₽",
      },
      {
        id: 10,
        title: "С/у АКПП (МКПП) тяжелого внедорожного а/м",
        price: "от 13000 ₽",
      },
      {
        id: 11,
        title:
          "Ремонт ГБЦ без снятия ГБЦ (притирка клапанов + замена прокладок + замена маслосъемных колпачков)",
        price: "от 4000 ₽",
      },
      {
        id: 12,
        title: "Замена ГРМ (рядный ДВС одновальный SOHC)",
        price: "от 4500 ₽",
      },
      {
        id: 13,
        title: "Замена ГРМ (рядный ДВС двухвальный DOHC)",
        price: "от 6500 ₽",
      },
      {
        id: 14,
        title: "Замена ГРМ (V-образный ДВС одновальный SOHC)",
        price: "от 8000 ₽",
      },
      {
        id: 15,
        title: "Замена ГРМ (V-образный ДВС двухвальный DOHC)",
        price: "от 9000 ₽",
      },
      {
        id: 16,
        title: "Замена прокладки ГБЦ",
        price: "от 15000 ₽",
      },
      {
        id: 17,
        title: "Капитальный ремонт * ДВС (рядный ДВС 4-х циллиндровый)",
        price: "от 35000 ₽",
      },
      {
        id: 18,
        title: "Капитальный ремонт * ДВС (рядный ДВС 5-ти циллиндровый)",
        price: "от 45000 ₽",
      },
      {
        id: 19,
        title: "Капитальный ремонт * ДВС (рядный ДВС 6-ти циллиндровый)",
        price: "от 55000 ₽",
      },
      {
        id: 20,
        title:
          "Капитальный ремонт * ДВС (V-образный ДВС 6-ти, 8-ми циллиндровый)",
        price: "от 65000 ₽",
      },
    ],
    repairEngine: [
      {
        id: 1,
        title: "Замер компрессии (1-го циллиндра)",
        price: "от 250₽",
      },
      {
        id: 2,
        title: "Замена приводного ремня",
        price: "от 450₽",
      },
      {
        id: 3,
        title: "Замена сальника",
        price: "от 500₽",
      },
      {
        id: 4,
        title: "С/у шкива",
        price: "от 500₽",
      },
      {
        id: 5,
        title: "Замена ролика",
        price: "от 500₽",
      },
      {
        id: 6,
        title: "Замена натяжителя",
        price: "от 600₽",
      },
      {
        id: 7,
        title: "Замена прокладки клапанной крышки",
        price: "от 900₽",
      },
      {
        id: 8,
        title: "Замена помпы (без учета стоимости с/у ГРМ)",
        price: "от 900₽",
      },
      {
        id: 9,
        title: "Замена термостата",
        price: "от 900₽",
      },
      {
        id: 10,
        title: "С/у маховика",
        price: "от 900₽",
      },
      {
        id: 11,
        title: "Чистка клапана холостого хода",
        price: "от 900₽",
      },
      {
        id: 12,
        title: "Замена общего приводного ремня",
        price: "от 1500₽",
      },
      {
        id: 13,
        title: "Чистка дроссельной заслонки (с адаптацией)",
        price: "от 1500₽",
      },
      {
        id: 14,
        title: "Чистка инжектора (без расходных материалов)",
        price: "от 1800₽",
      },
      {
        id: 15,
        title: "Замена прокладки поддона картера",
        price: "от 2000₽",
      },
      {
        id: 16,
        title: "Регулировка клапанов (рядный ДВС 4-х циллиндровый)",
        price: "от 2500₽",
      },
      {
        id: 17,
        title: "Замена ШРУСа",
        price: "от 2500₽",
      },
      {
        id: 18,
        title: "Замена пыльника ШРУСа",
        price: "от 2500₽",
      },
      {
        id: 19,
        title: "С/у подрамника",
        price: "от 3000₽",
      },
      {
        id: 20,
        title: "С/у рулевой рейки легкового а/м",
        price: "от 5000₽",
      },
      {
        id: 21,
        title: "С/у рулевой рейки внедорожника",
        price: "от 8000₽",
      },
      {
        id: 22,
        title: "Замена продольного рычага",
        price: "от 900₽",
      },
      {
        id: 23,
        title: "Замена поперечного рычага",
        price: "от 900₽",
      },
      {
        id: 24,
        title: "Замена рулевой тяги",
        price: "от 900₽",
      },
      {
        id: 25,
        title: "Замена суппорта в сборе",
        price: "от 1000₽",
      },
      {
        id: 26,
        title: "Замена тормозного диска + замена колодок",
        price: "от 1100₽",
      },
      {
        id: 27,
        title: "Замена верхнего рычага",
        price: "от 1300₽",
      },
      {
        id: 28,
        title: "Замена верхнего рычага",
        price: "от 1300₽",
      },
      {
        id: 29,
        title: "Замена треугольного рычага",
        price: "от 1500₽",
      },
      {
        id: 30,
        title: "Замена приводного вала (в сборе)",
        price: "от 1800₽",
      },
      {
        id: 31,
        title: "Регулировка развал схождения малый и средний класс",
        price: "от 1800₽",
      },
      {
        id: 32,
        title: "Замена заднего амортизатора",
        price: "от 2000₽",
      },
      {
        id: 33,
        title: "Замена заднего продольного рычага",
        price: "от 2200₽",
      },
      {
        id: 34,
        title: "Регулировка развал схождения представительский класс, внедорожники, минивэны",
        price: "от 2200₽",
      },
      {
        id: 35,
        title: "Замена переднего амортизатора + опорного подшипника + пружины",
        price: "от 2250₽",
      },
      {
        id: 36,
        title: "Замена задних тормозных колодок (барабанные)",
        price: "от 2500₽",
      },
      {
        id: 37,
        title: "Замена вакуумного усилителя тормозов",
        price: "от 2500₽",
      },
      {
        id: 38,
        title: "Замена подшипника ступицы",
        price: "от 2500₽",
      },
    ],
    repairLocksmith : [
      {
        id: 1,
        title: "Регулировка ручного тормоза",
        price: "от 200₽",
      },
      {
        id: 2,
        title: "Замена тормозного шланга",
        price: "от 300₽",
      },
      {
        id: 3,
        title: "Диагностика тормозной системы",
        price: "от 500₽",
      },
      {
        id: 4,
        title: "Диагностика ходовой системы",
        price: "от 500₽",
      },
      {
        id: 5,
        title: "Перепрессовка сайлент-блока",
        price: "от 500₽",
      },
      {
        id: 6,
        title: "Замена тормозного барабана",
        price: "от 600₽",
      },
      {
        id: 7,
        title: "Прокачка тормозов",
        price: "от 630₽",
      },
      {
        id: 8,
        title: "Замена рулевого наконечника",
        price: "от 630₽",
      },
      {
        id: 9,
        title: "Замена шаровой опоры",
        price: "от 630₽",
      },
      {
        id: 10,
        title: "Замена 1-й стойки стабилизатора",
        price: "от 650₽",
      },
      {
        id: 11,
        title: "Замена 1-й втулки стабилизатора",
        price: "от 630₽",
      },
      {
        id: 12,
        title: "Замена передних тормозных колодок (дисковые)",
        price: "от 700₽",
      },
      {
        id: 13,
        title: "Замена задних тормозных колодок (дисковые)",
        price: "от 700₽",
      },
      {
        id: 14,
        title: "Замена передних тормозных колодок (дисковые с датчиками)",
        price: "от 800₽",
      },
      {
        id: 15,
        title: "Замена заднего тормозного циллиндра",
        price: "от 900₽",
      },
      {
        id: 16,
        title: "Диагностика ходовой системы + тормозной системы",
        price: "от 900₽",
      },
      {
        id: 17,
        title: "Замена топливного фильтра - дизель",
        price: "от 1100₽",
      },
      {
        id: 18,
        title: "Замена масла в автоматической коробке передач (АКПП)",
        price: "от 1500₽",
      },
      {
        id: 19,
        title: "Замена масла в механической коробке передач (МКПП) + с/у поддона + замена фильтра",
        price: "от 2500₽",
      },
      {
        id: 20,
        title: "Замена топливного фильтра (погружного)",
        price: "от 2500₽",
      },
    ],
    maintenance: [
      {
        id: 1,
        title: "С/у защиты двигателя",
        price: "от 200₽",
      },
      {
        id: 2,
        title: "Замена воздушного фильтра",
        price: "от 200₽",
      },
      {
        id: 3,
        title: "Замена свечей зажигания (1 шт)",
        price: "от 200₽",
      },
      {
        id: 4,
        title: "Замена масла в двигателе (ДВС) + маслянный фильтр",
        price: "от 600₽",
      },
      {
        id: 5,
        title: "Замена салонного фильтра",
        price: "от 630₽",
      },
      {
        id: 6,
        title: "Замена масла в механической коробке передач (КПП)",
        price: "от 900₽",
      },
      {
        id: 7,
        title: "Замена масла в редукторе",
        price: "от 900₽",
      },
      {
        id: 8,
        title: "Замена масла в ведущем мосту",
        price: "от 900₽",
      },
      {
        id: 9,
        title: "Замена тормозной жидкости с прокачкой",
        price: "от 900₽",
      },
      {
        id: 10,
        title: "Замена охлаждающей жидкости, тосола",
        price: "от 900₽",
      },
      {
        id: 11,
        title: "Замена жидкости ГУР",
        price: "от 900₽",
      },
      {
        id: 12,
        title: "Замена топливного фильтра - бензин",
        price: "от 900₽",
      },
      {
        id: 13,
        title: "С/у коллектора",
        price: "от 1000₽",
      },
      {
        id: 14,
        title: "Замена топливного фильтра",
        price: "от 1100₽",
      },
    ]
  }}

function App() {
  return (
    <div className="App">
      
        <Header />
      
      <Main store={store}/>
      <Footer /></div>
   
  );
}

export default App;
